import { useQuery } from '@tanstack/react-query'
import type { DailyCardResponseDto, OrbitResponseDto, StreakDto } from '@lunary/api-client'
import { api } from '../../shared/api/client'
import { guestOpened } from '../../shared/lib/daily-open'

const DAY_MS = 86_400_000

function moscowToday(): Date {
  const iso = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow' }).format(new Date())
  return new Date(`${iso}T00:00:00Z`)
}

function guestWeek(today: Date): StreakDto['week'] {
  const weekday = ((today.getUTCDay() + 6) % 7) + 1
  const monday = today.getTime() - (weekday - 1) * DAY_MS
  return Array.from({ length: 7 }, (_, i) => ({
    date: new Date(monday + i * DAY_MS).toISOString().slice(0, 10),
    weekday: i + 1,
    picked: false,
    today: i + 1 === weekday,
  }))
}

export function useGuestOrbit(enabled: boolean) {
  return useQuery({
    queryKey: ['expert-daily-card', 'orbit-guest'],
    queryFn: () => api.get<DailyCardResponseDto | null>('/daily-card').catch(() => null),
    enabled,
    retry: false,
    select: (dayCard): OrbitResponseDto => {
      const today = moscowToday()
      return {
        date: today.toISOString().slice(0, 10),
        display_name: null,
        avatar_url: null,
        day_card: dayCard,
        day_card_opened: dayCard !== null && guestOpened(dayCard.date),
        personal_arcana: null,
        pick: null,
        pick_status: 'not_published',
        can_pick: false,
        streak: { days: 0, week: guestWeek(today) },
        reading: null,
      }
    },
  })
}
